var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header clearfix"},[_c('p',{staticClass:"fl"},[_vm._v("欢迎进入酷聊官网")]),_c('p',{staticClass:"fr"},[_c('span',{staticClass:"language Chinese"},[_vm._v("简")]),_vm._v(" / "),_c('span',{staticClass:"language",on:{"click":_vm.languageChange}},[_vm._v("EN")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }